import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TuiHint, TuiIcon, TuiNotification } from '@taiga-ui/core';
import { TuiTooltip } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-callout',
  imports: [TuiNotification, TuiHint, TuiIcon, TuiTooltip],
  templateUrl: './callout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutComponent {
  @Input() icon: string;
  @Input() appearance = 'info';
  @Input() containerClass: string;
  @Input() description: string;
  @Input() hint: string;
}
